import * as Device from 'react-device-detect';

import DesktopHeader from './DesktopHeader';
import MobileHeader from './MobileHeader';

import { HeaderProps } from './types';

function Header(props: HeaderProps) {
  return Device.isMobileOnly ? <MobileHeader {...props} /> : <DesktopHeader {...props} />;
}

export default Header;
